import { Accordion, Card, Grid, InputText } from "#/atoms";
import { FC, memo } from "react";

import { DESKTOP_SPACING } from "@/theme";
import { GenericServiceProps } from "./OrderService.interface";
import { HeadingIcon } from "#/molecules";

const WalklyService: FC<GenericServiceProps> = ({
  amount,
  externalUrl,
  isAdmin,
  name,
  onChangeUrl,
  serviceId
}) => {
  const accordionState = 'open';

  return (
    <Card>
        <Accordion
          header={<HeadingIcon icon="services" mb={`${DESKTOP_SPACING.XXL}px`} title={`${name} ${amount ? " X" + amount : ""}`} />}
          showArrow
          state={accordionState}
        >

         { isAdmin && <Grid columnGap={DESKTOP_SPACING.XL} gridTemplateColumns="repeat(2, 40%)" margin="0">
            <InputText
                type="text"
                label="VideoMotion URL"
                value={externalUrl}
                onChange={(e) => onChangeUrl?.(e.target.value, serviceId)}
              />
          </Grid> }
          { externalUrl &&
          <iframe src={externalUrl} style={{height: "600px", width: "100%"}}></iframe> }
        </Accordion>
    </Card>
  );
}

export default memo(WalklyService);